export default [
  {
    path: "/resources",
    name: "resources",
    permission: "access_offering",
    component: () => import("@/views/lms/index"),
    meta: { pageTitle: "LMS", breadcrumb: [{ text: "LMS", active: true }] },
  },
];
